export const getLoadStatusTextColor = (status) => {
	switch (status) {
		case "Upcoming":
			return "#FFFFFF";
		case "Dispatched":
			return "#00008B";
		case "At PU":
			return "#6d6a08";
		case "en Route":
			return "#603e02";
		case "At DO":
			return "#664c18";
		default:
			return "black";
	}
};

export const getLoadPaymentStatusTextColor = (status) => {
	switch (status) {
		case "Delivered":
			return "#528C42";
		case "Invoiced":
			return "black";
		case "Paid":
			return "white";
		case "This week":
			return "white";
		case "Next week":
			return "white";
		case "Overdue":
			return "white";
		case "Due":
			return "white";
		case "Cancelled":
			return "white";
		case "Issue":
			return "black";
		case "Factored":
			return "black";
		case "Not set":
			return "black";
		case "On Our Load":
			return "white";
		default:
			return "black";
	}
};
